import { useCallback } from 'react';
import { useClient } from 'urql';

import {
  ScanToPayPaymentMethodsDocument,
  type ScanToPayPaymentMethodsQuery,
} from '../../graphql/ScanToPayPaymentMethods.generated';
import { type PaymentMethod } from '../../machine/scan-to-pay.machine.types';

// ────────────────────────────────────────────────────────────────────────────

/**
 * A hook for fetching the available payment methods.
 */
export const useScanToPayPaymentMethods = () => {
  const client = useClient();

  // ─── Queries ──────────────────────────────────────────────────────────────

  const fetchPaymentMethods = useCallback(async () => {
    const queryPaymentMethods = client.query<ScanToPayPaymentMethodsQuery>;

    const response = await queryPaymentMethods(
      ScanToPayPaymentMethodsDocument,
      {},
      { requestPolicy: 'network-only' },
    ).toPromise();

    const paymentMethods = response.data?.paymentMethodCards ?? [];

    return { paymentMethods: paymentMethods as readonly PaymentMethod[] };
  }, [client.query]);

  // ──────────────────────────────────────────────────────────────────────────

  return { fetchPaymentMethods };
};
